var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('lottie',{staticClass:"animation1",attrs:{"options":_vm.defaultOptions,"autoplay":true,"speed":0.05,"loop":false,"height":200,"width":200},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }